export enum ShippingOptionType {
  Shippings = 'shippings',
  PyramydShippings = 'pyramydShippings',
}

export type ShippingOptionsData = {
  internalOrder: boolean;
  [ShippingOptionType.Shippings]: Array<Shippings>;
  [ShippingOptionType.PyramydShippings]: Array<Shippings>;
};

export type Shippings = {
  suborderId: number;
  calculateShippings: Array<ShippingOptionItem> | Array<PyramidShippingItem>;
};

export type ShippingOptionItem = {
  allowSignatureRequired: boolean;
  methodId: number;
  name: string;
  sum: number;
  deliveryTime: string;
  latestDeliveryDate: string;
  image: string | null;
};

export type PyramidShippingItem = {
  allowSignatureRequired: boolean;
  number: number;
  deliveryDate: string;
  latestDeliveryDate: string;
  name: string;
  price: number;
  image: string | null;
};

export type ShippingAddress = {
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string | null;
  country: string;
  state: string;
  city: string;
  zipcode: string;
  isResidential?: boolean;
  phoneNumber?: string;
};

export type ShippingEstimate = {
  shippingMethodNumber: number;
  shippingMethodName: string;
  currency: string;
  price: number;
};

export type SignatureConfiguration = {
  currentUserThreshold: number;
  signatureCost: number;
};

export type ShippingEstimateApiResponse = {
  zipCode: string;
  country: string;
  shippingRates: Array<ShippingEstimate>;
  errorResponseDTO: {
    code: string;
    error: string;
  } | null;
};
